export const SEARCH_SORT_RELEVANCE = "relevance";
export const SEARCH_SORT_POPULAR = "popular";
export const SEARCH_RESULTS_TO_SHOW_MOBILE = 10;
export const SEARCH_RESULTS_TO_SHOW_STEPSIZE_MOBILE = 10;
export const SEARCH_RESULTS_TO_SHOW_TABLET = 10;
export const SEARCH_RESULTS_TO_SHOW_STEPSIZE_TABLET = 10;
export const SEARCH_RESULTS_TO_SHOW_DESKTOP = 10;
export const SEARCH_RESULTS_TO_SHOW_STEPSIZE_DESKTOP = 10;
export const PRODUCTS_AND_SERVICES_ROOT = "lumen:";
export const PRODUCTS_AND_SERVICES_LABEL = "Products & Services";
export const PORTAL_ROOT = "help:portal";
export const PORTAL_LABEL = "Portal";
export const READINESS_ROOT = "help:readiness";
export const READINESS_LABEL = "Readiness";
export const GENERAL_TOPICS_ROOT = "help:general-topics";
export const GENERAL_TOPICS_LABEL = "General Topics";
